<form [formGroup]="formGroup">
    <p-toolbar>
        <p-calendar
            #filterDates
            *ngIf="showFilterDates"
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2000:2030"
            appendTo="body"
            selectionMode="range"
            formControlName="ReconDates"
        ></p-calendar>
        <p-select
            #payPeriod
            *ngIf="showPayPeriods"
            appendTo="body"
            [autoDisplayFirst]="false"
            [options]="payPeriodDates"
            formControlName="PayPeriod"
        >
        </p-select>
        <p-select
            *ngIf="showTemplates"
            appendTo="body"
            [options]="templates"
            formControlName="ReconTemplate"
        ></p-select>
        <button
            hidden
            pButton
            label="Memorize"
            (click)="Memorize.next()"
        ></button>
    </p-toolbar>
</form>
